import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { AssignmentItemList } from '../../models/Assignment';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { AssignmentSidebarDatesForm } from '../AssignmentSidebar/AssignmentSidebarDatesForm';
import { Button } from 'primereact/button';
import { AssignmentUpdateMutation$variables } from '../../graphQLOperations/__generated__/AssignmentUpdateMutation.graphql';
import { formatAssignmentDateRange } from '../../businessLogicService/formatAssignmentDateRange';

interface Props {
  assignment: AssignmentItemList;
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  updateAssignmentHandler: (variables: AssignmentUpdateMutation$variables) => void;
}

export const AssignmentEditModal: FC<Props> = ({ assignment, setVisible, visible, updateAssignmentHandler }) => {
  const [assignmentName, setAssignmentName] = useState('');
  const [dateFrom, setDateFrom] = useState<Date>(new Date(assignment.startedOn));
  const [dateTo, setDateTo] = useState<Date>(new Date(assignment.dueOn));
  const [invalidName, setInvalidName] = useState(false);

  useEffect(() => {
    setAssignmentName(assignment.name);
    setDateFrom(new Date(assignment.startedOn));
    setDateTo(new Date(assignment.dueOn));
  }, [assignment, visible]);

  const updateAssignment = () => {
    if (assignmentName.trim() === '') {
      return setInvalidName(true);
    }
    const { startedOn, dueOn } = formatAssignmentDateRange(dateFrom, dateTo);

    updateAssignmentHandler({
      input: {
        assignmentId: assignment.id,
        dueOn,
        startedOn,
        name: assignmentName,
      },
    });
    setVisible(false);
  };

  const footer = () => {
    return (
      <div className="flex justify-content-between w-full">
        <Button outlined className="border-none" label="Cancel" onClick={() => setVisible(false)} />
        <Button icon="nc_icon-nc_save icon-sm" label="Save" onClick={() => updateAssignment()} />
      </div>
    );
  };

  return (
    <Dialog footer={footer()} className="w-5" onHide={() => setVisible(false)} visible={visible} header="Edit">
      <div>
        <div className="field mx-auto col-12">
          <label htmlFor="assignment-name" className={`${invalidName ? 'p-error' : ''}`}>
            New assignment name
          </label>
          <InputText
            invalid={invalidName}
            value={assignmentName}
            onChange={e => {
              setInvalidName(false);
              setAssignmentName(e.target.value);
            }}
            placeholder="E.g.: Homework for next week"
            className="w-full"
            id="asssignment-name"
          />
          {invalidName && (
            <p className="p-error py-0 my-0 font-semibold">
              You need to assign a name to the assignment before proceeding.
            </p>
          )}
        </div>
        <AssignmentSidebarDatesForm
          toDate={dateTo}
          fromDate={dateFrom}
          setFromDate={setDateFrom}
          setToDate={setDateTo}
        />
      </div>
    </Dialog>
  );
};
